import { useState, useEffect, useRef } from "react";
import { inject, observer } from "mobx-react";

import ButtonUI from "@UI/ButtonUI";

import { TabMenu } from "primereact/tabmenu";
import { MultiSelect } from "primereact/multiselect";

import "./style.scss";

const HeaderTabs = inject("mainStore")(
    observer(({ mainStore }) => {
        const dataOptions = mainStore.getMainStore("suggest.sites_suggest");
        const auth = mainStore.getMainStore("auth");
        const siteIds = mainStore.getMainStore("filter.filters.siteIds");

        const [btns, setBtns] = useState(initialBtns);
        const [dropdownValue, setDropdownValue] = useState(initialBtns.map((i) => i.id));
        const [isSelectOpen, setIsSelectOpen] = useState(false);

        const multiSelectRef = useRef(null);

        const saved = sessionStorage.getItem("companies_tab_active");
        const currentId = siteIds?.[0] ?? null;

        useEffect(() => {
            const newTab = JSON.parse(saved);

            if (newTab) {
                if (auth?.config?.companiesTabs) {
                    const isTabList = auth?.config?.companiesTabs.findIndex((f) => f.id === newTab[0].id);

                    if (isTabList !== -1) {
                        handleTab(null, isTabList);
                        setBtns(auth.config.companiesTabs);
                        setDropdownValue(auth.config.companiesTabs.map((i) => i.id));
                    } else {
                        handleTab(newTab[0].id, auth?.config?.companiesTabs.concat(newTab).length - 1);
                        setBtns(auth.config.companiesTabs.concat(newTab));
                        setDropdownValue(auth.config.companiesTabs.concat(newTab).map((i) => i.id));
                    }

                    sessionStorage.removeItem("companies_tab_active");
                }
            } else {
                if (auth?.config?.companiesTabs) {
                    setBtns(auth.config.companiesTabs);
                    setDropdownValue(auth.config.companiesTabs.map((i) => i.id));
                }
            }
        }, []);

        const activeIndex = (() => {
            if (!btns.length) return 0; // вкладка "Все"
            if (currentId == null) return 0; // вкладка "Все"

            const idx = btns.findIndex((b) => b.id == currentId);
            return idx >= 0 ? idx : 0;
        })();

        const handleTab = (id) => {
            const val = !id ? null : [id];
            mainStore.setMainStore(`filter.filters.siteIds`, val);
        };

        const syncTabs = async (newBtns, newDropdown, removedIdx = null) => {
            const resp = await mainStore.putByUrl(`/cms/users/${auth._id}`, { config: { companiesTabs: newBtns } }, false, false);

            if (!(resp && resp.success)) return;

            mainStore.setMainStore(`auth`, resp.data);
            setBtns(newBtns);
            setDropdownValue(newDropdown);

            if (!newDropdown.length) {
                handleTab(null); // если ничего не осталось — сбрасываем фильтр
                return;
            }

            // выясняем, какой id сейчас выбран
            const siteIds = mainStore.getMainStore("filter.filters.siteIds");
            const currentId = siteIds?.[0] ?? null;

            if (removedIdx != null) {
                const removedBtn = btns[removedIdx];
                const removedId = removedBtn?.id ?? null;

                // если удалили именно активный таб — выбираем соседний
                if (removedId != null && removedId === currentId) {
                    const newActiveIdx = Math.min(removedIdx, newBtns.length - 1);
                    const fallback = newBtns[newActiveIdx];
                    handleTab(fallback?.id ?? null);
                }
            }
        };

        const handleDropdownChange = (value) => {
            const removedIds = dropdownValue.filter((id) => !value.includes(id));
            const removedId = removedIds.length ? removedIds[0] : null;
            const selectedOptions = dataOptions.filter((opt) => value.includes(opt._id));
            const base = btns.filter((b) => b.id === null);
            const newBtns = [...base, ...selectedOptions.map((opt) => ({ label: opt.name, id: opt._id }))];

            let removedIdx = null;
            if (removedId) {
                removedIdx = btns.findIndex((b) => b.id === removedId);
            }

            syncTabs(newBtns, value, removedIdx);
        };

        const handleRemove = (idx) => {
            const newBtns = btns.filter((_, i) => i !== idx);
            const newDropdown = newBtns.filter((b) => b.id !== null).map((b) => b.id);
            syncTabs(newBtns, newDropdown, idx);
        };

        const itemRenderer = (item, options) => {
            return (
                <div className={`header-tabs__tab ${options.index === activeIndex ? "header-tabs__tab_active" : ""}`} onClick={options.onClick}>
                    <span className="font-bold">{item.label}</span>
                    {options.index > 0 ? (
                        <i
                            className="pi pi-times"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleRemove(options.index);
                            }}
                        ></i>
                    ) : null}
                </div>
            );
        };

        const model = btns.map((i) => ({ label: i.label, template: itemRenderer }));

        return (
            <div className="header-tabs">
                <TabMenu model={model} activeIndex={activeIndex} onTabChange={(e) => handleTab(btns[e.index].id, e.index)} />

                <ButtonUI className={`header-tabs__btn ${isSelectOpen ? "header-tabs__btn_active" : ""}`} onClick={() => multiSelectRef.current?.show()} label="Добавить" icon="pi pi-plus-circle" iconPos="right" />
                <MultiSelect
                    className="header-tabs__select"
                    ref={multiSelectRef}
                    placeholder="Другие"
                    filter
                    value={dropdownValue}
                    options={dataOptions || []}
                    optionLabel="name"
                    optionValue="_id"
                    onChange={(e) => handleDropdownChange(e.value)}
                    onShow={() => setIsSelectOpen(true)}
                    onHide={() => setIsSelectOpen(false)}
                />
            </div>
        );
    }),
);

const initialBtns = [
    { label: "Все", id: null },
    { label: "RIS promo", id: "65363d1ae368f2c1de818b11" },
    { label: "WB", id: "66db17b2c73e09e0e58fb496" },
    { label: "Авито", id: "687672f45a2f37a346d80840" },
    { label: "Магнит", id: "6810f3c82d93763cd58b2469" },
    { label: "Tbank", id: "67f61acc12a4a829e0aeb574" },
];

export default HeaderTabs;
